import React from "react";
import { IconT } from "types/utils";
import { theme } from "styles/themes";

const ZdChatShow = ({
  height = "28",
  width = "28",
  fill = theme.colors["blue-ribbon"],
  stroke = theme.colors.white,
}: IconT) => {
  return (
    <svg width={width} height={height} viewBox="0 0 28 28" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <rect width="28" height="28" rx="14" fill={fill} />
      <rect x="4" y="8" width="20" height="10" rx="5" fill={stroke} />
      <path d="M19.9998 23.3416L16.0397 19.3021L20.0048 19.3415L19.9998 23.3416Z" fill={stroke} />
    </svg>
  );
};
export default ZdChatShow;
